import { ComponentChildren } from 'preact';
import { cssProps } from '@oracle/oraclejet-cssprops';

const hiddenAccessibleStyle = cssProps`${{
  border: 0,
  clip: 'rect(0 0 0 0)',
  height: '1px',
  margin: '-1px',
  overflowX: 'hidden',
  overflowY: 'hidden',
  paddingTop: 0,
  paddingRight: 0,
  paddingBottom: 0,
  paddingLeft: 0,
  width: '1px',
  position: 'absolute'
}}`;

type HiddenAccessibleProps = {
  /**
   * Specifies the ComponentChildren
   */
  children?: ComponentChildren;
};

/**
 * HiddenAccessible is a helper component that hides its children visually,
 * but keeps them visible to screen readers.
 *
 */
function HiddenAccessible({ children }: HiddenAccessibleProps) {
  return <span class={hiddenAccessibleStyle}>{children}</span>;
}

export { HiddenAccessible };
